import React from 'react'
import ProductDetailRoot from '../components/pages/product-detail/product-detail-root'

const ProductPage = () => {
  return (
    <ProductDetailRoot />
  )
}

export default ProductPage